import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../CSS/FAQ.css";

const faqData = [

{
question: "What is Apostille and why is it required for Indian documents?",
answer: "Apostille is a form of document authentication issued by the Ministry of External Affairs (MEA), Government of India. It verifies that Indian documents are genuine and legally valid for use in countries that are members of the Hague Convention. Apostille is commonly required for education abroad, employment visas, immigration, and international business."
},

{
question: "Where can I get Apostille services in Mumbai?",
answer: "You can get professional apostille services in Mumbai through authorized document attestation agencies that handle document verification, state authentication, and submission to the Ministry of External Affairs for apostille certification."
},

{
question: "Which documents require Apostille in Mumbai?",
answer: "Documents that commonly require apostille in Mumbai include birth certificates, marriage certificates, police clearance certificates, affidavits, power of attorney documents, degree certificates, diplomas, mark sheets, and company documents for international use."
},

{
question: "How long does the Apostille process take in Mumbai?",
answer: "The apostille process in Mumbai generally takes between 3 to 7 working days depending on the type of document and the verification required by state authorities before submission to the Ministry of External Affairs."
},

{
question: "What is the difference between Apostille and Embassy Attestation?",
answer: "Apostille is required for countries that are members of the Hague Convention, while embassy attestation is required for countries that are not part of the Hague Convention. Both processes verify the authenticity of documents for international use."
},

{
question: "Is Apostille required for studying or working abroad?",
answer: "Yes, apostille is often required for students and professionals traveling abroad. Educational documents such as degree certificates, transcripts, and school certificates must be apostilled to be accepted by foreign universities, employers, and immigration authorities."
},

{
question: "Can commercial documents be apostilled in Mumbai?",
answer: "Yes, commercial documents such as certificates of incorporation, export documents, invoices, business agreements, and company registration certificates can also be apostilled for international trade and business expansion."
},

{
question: "Why should I use professional Apostille services in Mumbai?",
answer: "Professional apostille service providers in Mumbai simplify the process by handling document verification, attestation, and submission procedures. This ensures faster processing, accurate documentation, and hassle-free apostille certification."
}

];

const FAQ = () => {

const [activeIndex, setActiveIndex] = useState(null);

const toggleFAQ = (index) => {
setActiveIndex(activeIndex === index ? null : index);
};

return (

<div className="faq-page">

{/* HEADER */}

<div className="faq-banner">

<h1>Frequently Asked Questions</h1>

<p>
<Link to="/">Home</Link> › <span>FAQ</span>
</p>

</div>


{/* FAQ SECTION */}

<div className="faq-container">

<h2>Apostille Services FAQ</h2>

{faqData.map((faq, index) => (

<div key={index} className="faq-item">

<div
className="faq-question"
onClick={() => toggleFAQ(index)}
>

<h3>{faq.question}</h3>

<span>{activeIndex === index ? "-" : "+"}</span>

</div>

{activeIndex === index && (

<p className="faq-answer">
{faq.answer}
</p>

)}

</div>

))}

</div>

</div>

);
};

export default FAQ;